import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { finishAttempt, selectAttempts } from '../../features/applicant/TestView/attemptSlice';
import { Box, Typography } from '@mui/material';

const Timer = () => {
  const dispatch = useAppDispatch();
  const attemptsState = useAppSelector(selectAttempts);
  const [hours, setHours] = useState<number | null>(null);
  const [minutes, setMinutes] = useState<number | null>(null);
  const [seconds, setSeconds] = useState<number | null>(null);

  const updateTimer = (interval: NodeJS.Timer) => {
    if (!attemptsState.attempt) return;
    const time = (attemptsState.attempt.endTime.getTime() - Date.now()) / 1000; // time left in seconds
    if (time < 0) {
      clearInterval(interval);
      setHours(null);
      setMinutes(null);
      setSeconds(null);
      dispatch(finishAttempt());
      return;
    }
    setHours(Math.floor(time / (60 * 60)));
    setMinutes(Math.floor((time / 60) % 60));
    setSeconds(Math.floor(time % 60));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      updateTimer(interval);
    }, 1000);
    updateTimer(interval);
    return () => clearInterval(interval);
  }, []);

  if (!attemptsState.attempt) return null;
  if (attemptsState.finished) return <Typography>Finished</Typography>;
  return (
    <Box display="grid" gap={1} gridAutoColumns="1fr" gridAutoFlow="column">
      {!!hours && (
        <Box border={1} borderRadius={1} paddingX={1}>
          <Typography align="center">{hours}</Typography>
          <Typography align="center">hours</Typography>
        </Box>
      )}
      {(!!hours || !!minutes) && (
        <Box border={1} borderRadius={1} paddingX={1}>
          <Typography align="center">{minutes}</Typography>
          <Typography align="center">minutes</Typography>
        </Box>
      )}
      {seconds != null && (
        <Box border={1} borderRadius={1} paddingX={1}>
          <Typography align="center">{seconds}</Typography>
          <Typography align="center">seconds</Typography>
        </Box>
      )}
    </Box>
  );
};

export default Timer;
